import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-fout',
  templateUrl: './button-fout.component.html',
  styleUrls: ['./button-fout.component.less']
})
export class ButtonFoutComponent implements OnInit {
  @Input() caption = '';
  @Input() disabled = false;
  constructor() { }

  ngOnInit(): void {
  }

}
